// CSS Modules - component class name prefix: CookieDisclaimer__

<template>
  <transition name="scroll">
    <div v-if="show" :class="$style.container">
      <div :class="$style.inner">
        <span v-if="config.text" :class="$style.text">{{ config.text }}</span>
        <span :class="$style.right">
          <a
            v-if="config.link"
            :class="$style.link"
            :href="config.link.url"
            target="_self"
          >{{ config.link.text }}</a>
          <Button
            v-if="config.button"
            :text="config.button.text"
            :colour="config.button.colour"
            noBorder
            isForm
            @close="handleClick"
          />
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from "../Button/Button";
import * as Storage from "../../shared/Storage";

export default {
  name: "CookieDisclaimer",
  components: {
    Button
  },
  data() {
    return {
      show: false,
      cookieName: "hideCookieMessage"
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (Storage.getCookie(this.cookieName) === "") {
      setTimeout(() => {
        this.show = true;
      }, 1200);
    }
  },
  methods: {
    handleClick() {
      Storage.setCookie(this.cookieName, true, 365);
      this.show = false;
    }
  }
};
</script>

<style module lang="scss">
@import "./CookieDisclaimer.scss";
</style>
